module.exports = __webpack_public_path__ + "fonts/Sparkasse_web_Lt.cb52eddc.woff";